import {
    COMPETITOR_BRAND_ERROR_KEYS,
    type ICompetitorBrandError,
    type ICompetitorBrandValidation,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/competitor-section/types";

export const getCompetitorBrandNfkcError = (brand: string): ICompetitorBrandError | null => {
    if (!brand || brand === brand.normalize("NFKC")) {
        return null;
    }

    const nfkc = brand.normalize("NFKC");
    const nfc = brand.normalize("NFC");

    // Combining marks look identical after NFC, so a "fixed" suggestion would be indistinguishable
    // from the rejected input - ask to re-type instead of echoing it back.
    return nfc !== nfkc
        ? { key: COMPETITOR_BRAND_ERROR_KEYS.invalidCharacters, params: { suggestion: nfkc } }
        : { key: COMPETITOR_BRAND_ERROR_KEYS.notComposed };
};

export const validateCompetitorBrand = (brand: string, existingBrands: string[]): ICompetitorBrandValidation => {
    const trimmedBrand = brand.trim();

    if (!trimmedBrand) {
        return { trimmedBrand, brandValidationError: { key: COMPETITOR_BRAND_ERROR_KEYS.empty } };
    }

    const lowercaseBrand = trimmedBrand.toLowerCase();
    if (existingBrands.some((existing) => existing.toLowerCase() === lowercaseBrand)) {
        return { trimmedBrand, brandValidationError: { key: COMPETITOR_BRAND_ERROR_KEYS.duplicate } };
    }

    return { trimmedBrand, brandValidationError: getCompetitorBrandNfkcError(trimmedBrand) };
};
